import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80c711da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Nav" }
const _hoisted_2 = { class: "navmain" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "Nav-item-name" }


import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  navList: {
    type: Array as () => Array<any>,
    default: () => []
  },
  index: {
    type: Number,
    default: null
  }
},
  emits: ['changeType'],
  setup(__props, { emit: emits }) {

const props = __props




// 导航栏切换
const changeType = (index: number) => {
  emits('changeType', index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["navmain-item", { active: item.value === __props.index }]),
          key: item.value,
          onClick: ($event: any) => (changeType(item.value))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(item.label)), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})